import { VxNode } from './parser.js';
import { VxRenderOptions } from './render.js';
import { VxTreeView } from './tree.js';

export class VxPageView {

    private vxTreeMap = new Map<string, VxTreeView>();

    constructor(vxTrees: VxTreeView[]) {
        for (const vxTree of vxTrees) {
            this.vxTreeMap.set(vxTree.frameId, vxTree);
        }
    }

    get vxTrees() {
        return [...this.vxTreeMap.values()];
    }

    get nodeCount() {
        return this.vxTrees.reduce((acc, vxTree) => acc + vxTree.nodeCount, 0);
    }

    findNodeByRef(ref: string): VxNode | null {
        const frame = this.findFrameByRef(ref);
        if (frame == null) {
            return null;
        }
        return frame.findNode(ref);
    }

    findFrameById(frameId: string): VxTreeView | null {
        return this.vxTreeMap.get(frameId) ?? null;
    }

    findFrameByRef(ref: string): VxTreeView | null {
        const frame = this.vxTrees.find(f => f.hasRef(ref));
        return frame ?? null;
    }

    getFrameByRef(ref: string): VxTreeView {
        const frame = this.findFrameByRef(ref);
        if (frame == null) {
            throw new Error(`[VX] Frame not found for [ref=${ref}]`);
        }
        return frame;
    }

    findParentFrame(frameId: string): VxTreeView | null {
        const frame = this.findFrameById(frameId);
        const iframeRef = frame?.iframeRef;
        if (iframeRef == null) {
            return null;
        }
        return this.findFrameByRef(iframeRef);
    }

    isFrameShown(frameId: string): boolean {
        const frame = this.findFrameById(frameId);
        if (!frame) {
            return false;
        }
        const parentFrame = this.findParentFrame(frameId);
        const { iframeRef } = frame;
        if (parentFrame == null || iframeRef == null) {
            // Top level document is always shown
            return true;
        }
        const existsInParent = !!parentFrame.findNode(iframeRef);
        return existsInParent ? this.isFrameShown(parentFrame.frameId) : false;
    }

    renderAll(options: VxRenderOptions) {
        return this.vxTrees.map(frame => {
            const rendered = frame?.render(options);
            return [
                `FRAME ${frame.frameId}${frame.iframeRef ? ` [@${frame.iframeRef}]` : ''}`,
                rendered,
            ].join('\n\n');
        }).join('\n\n');
    }

}
